import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, tap } from 'rxjs/operators';
import { AttachImageUrl } from '../functions/attach-img-url.funtion';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  getMyInfo() {
    return this.http.put(environment.API_URL + '/admin/user/common/specific', {
      userId: localStorage.getItem('id')
    }).pipe(
      map((res: any) => {
        AttachImageUrl(res.data, ['picture', 'thumbPic', 'personalPicture', 'marketerContractPicture'], 'u');
        return res.data[0];
      }),
      tap(res => localStorage.setItem('parentId', String(res.parentId)))
    );
  }
  getChildhoodTree() {
    return this.http.get(environment.API_URL + '/admin/user/childhoodTree').pipe(
      map((res: any) => {
        AttachImageUrl(res.data, ['picture'], 'u');
        return res.data;
      }));
  }
  setScoreForMarketer(payload) {
    return this.http.post(environment.API_URL + '/admin/user/setScoreForMarketer', payload).pipe(
      map((res: any) => res.data),
    );

  }
  getMessages() {
    return this.http.get(environment.API_URL + '/admin/message/specialUser/all').pipe(
      map((res: any) => {
        AttachImageUrl(res.data, ['adminThumbpic'], 'u');
        return res.data;
      }),
    );
  }
  getDetailsMessages(messageId) {
    return this.http.put(environment.API_URL + '/admin/message/specialUser/specific', { messageId }).pipe(
      map((res: any) => res.data),
    );
  }
  visitMessages(messageId) {
    return this.http.put(environment.API_URL + '/admin/message/specialUser/visit', { messageId }).pipe(
      map((res: any) => res.data),
    );
  }
  deteleMessages(messageId) {
    return this.http.put(environment.API_URL + '/admin/message/specialUser/delete', { messageId }).pipe(
      map((res: any) => res.data),
    );
  }
  addUser(data: string, picture: File) {
    const formData: FormData = new FormData();
    formData.append('data', data);
    if (picture) {
      formData.append('picture', picture, picture.name);
    }
    const req = new HttpRequest('POST', environment.API_URL + '/admin/user/specialUser', formData);
    return this.http.request(req);
  }
  deleteUser(id) {
    const req = new HttpRequest('DELETE', environment.API_URL + '/admin/user/common/' + id);
    return this.http.request(req);
  }

}
